import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07ce7890"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "StepProducts" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "StepProducts__title" }, "Формирование товаров", -1))
const _hoisted_3 = { class: "mt-3 grid grid-cols-3 gap-3" }
const _hoisted_4 = { class: "mt-3 flex justify-end items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_the_input, {
        disabled: _ctx.disabled,
        value: _ctx.state.title,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.title) = $event)),
        "is-invalid": _ctx.state_form$.title.$error,
        "validation-errors": _ctx.state_form$.title.$errors,
        placeholder: "Наименование товара"
      }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        disabled: _ctx.disabled,
        autocomplete: false,
        value: _ctx.state.price,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.price) = $event)),
        "is-invalid": _ctx.state_form$.price.$error,
        "validation-errors": _ctx.state_form$.price.$errors,
        placeholder: "Цена товара"
      }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        disabled: _ctx.disabled,
        autocomplete: false,
        value: _ctx.state.count,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.count) = $event)),
        "is-invalid": _ctx.state_form$.count.$error,
        "validation-errors": _ctx.state_form$.count.$errors,
        type: "number",
        placeholder: "Количество"
      }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_the_button, {
        disabled: _ctx.disabled,
        class: "primary small text",
        onClick: _ctx.onSubmit
      }, {
        default: _withCtx(() => [
          _hoisted_5,
          _createTextVNode(" Добавить товар ")
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ])
  ]))
}